module.exports = __webpack_public_path__ + "media/ship-horn.60fc68e1.mp3";